export default __webpack_public_path__ + "static/media/azure-api-management.cfa04486.svg";